<template>
  <div id="app" class="h-100" :class="[skinClasses]">
    <component :is="layout">
      <router-view />
    </component>
    <verification />
    <scroll-to-top v-if="enableScrollToTop" />
  </div>
</template>

<script>
import ScrollToTop from "@core/components/scroll-to-top/ScrollToTop.vue";
// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from "@themeConfig";
// import { provideToast } from "vue-toastification/composition";
import Verification from "@core/components/verification/Verification.vue";
import { watch } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";

import { useWindowSize, useCssVar } from "@vueuse/core";

import store from "@/store";
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from "@/auth/utils";
const LayoutVertical = () => import("@/layouts/vertical/LayoutVertical.vue");
// const LayoutHorizontal = () =>
//   import("@/layouts/horizontal/LayoutHorizontal.vue");
const LayoutFull = () => import("@/layouts/full/LayoutFull.vue");
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  isMobile,
  // isTablet,
  // isIOS,
  // isSmartTV,
  osName,
  osVersion,
  mobileVendor,
  mobileModel,
} from "mobile-device-detect";

export default {
  components: {
    Verification,
    // Layouts
    // LayoutHorizontal,
    LayoutVertical,
    LayoutFull,

    ScrollToTop,
  },

  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    verifyType: {
      get() {
        return this.$store.state.auth.verifyType;
      },
      set(val) {
        this.$store.dispatch("auth/setVerifyType", val);
      },
    },
    visibleCheckUser: {
      get() {
        return this.$store.state.auth.visibleCheckUser;
      },
      set(val) {
        this.$store.dispatch("auth/setVisibleCheckUser", val);
      },
    },
    layout() {
      if (this.$route.meta.layout === "full") return "layout-full";
      return `layout-${this.contentLayoutType}`;
    },
    userData() {
      return this.$store.state.auth.userData || {};
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type;
    },
  },

  methods: {
    async getUser() {
      try {
        const { data } = await this.$http.get("/panel/profile");
        if (!data.data.mobile_verified_at) {
          this.visibleCheckUser = true;
          this.verifyType = "mobile";
        }
        if (!data.data.email_verified_at) {
          this.visibleCheckUser = true;
          this.verifyType = "email";
        }
      } catch (err) {
        // if (err.response.status == 401) {
        //   await this.logout();
        //   this.$toast({
        //     component: ToastificationContent,
        //     props: {
        //       title: "توکن شما منقضی شده است",
        //       icon: "EditIcon",
        //       variant: "danger",
        //     },
        //   });
        // }
      }
    },
    // logout() {
    //   // Remove userData from localStorage
    //   localStorage.removeItem("userData");
    //   this.$store.dispatch("auth/setUserData", {});
    //   localStorage.removeItem("token");
    //   this.$http.defaults.headers.common["Authorization"] = ``;
    //   // Redirect to login page
    //   this.$router.push({ name: "auth-login" });
    // },
  },

  async beforeCreate() {
    //set user data
    await this.$store.dispatch(
      "auth/setUserData",
      localStorage.getItem("tempUserData")
        ? JSON.parse(localStorage.getItem("tempUserData"))
        : JSON.parse(localStorage.getItem("userData"))
    );
    // Set colors in theme
    const colors = [
      "primary",
      "secondary",
      "success",
      "info",
      "warning",
      "danger",
      "light",
      "dark",
    ];
    // this.$store.commit(
    //   "appConfig/UPDATE_NAV_MENU_HIDDEN",
    //   JSON.parse(localStorage.getItem("userData")).type === "users"
    // );
    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(
        `--${colors[i]}`,
        document.documentElement
      ).value.trim();
    }

    // Set Theme Breakpoints
    const breakpoints = ["xs", "sm", "md", "lg", "xl"];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(
        useCssVar(
          `--breakpoint-${breakpoints[i]}`,
          document.documentElement
        ).value.slice(0, -2)
      );
    }
    // Set RTL
    const { isRTL } = $themeConfig.layout;
    document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
    //set user device
    const device = isMobile
      ? mobileModel + " " + mobileVendor
      : osName + " " + osVersion;
    this.$store.dispatch("appConfig/getDevice", device);
    //set token
    const token = (await localStorage.getItem("user_token"))
      ? JSON.parse(localStorage.getItem("user_token"))
      : JSON.parse(localStorage.getItem("token"));
    if (token)
      this.$http.defaults.headers.common["Authorization"] =
        await `${token.type} ${token.val}`;
    // const isAdmin =
    //   this.$store.state.auth.userData &&
    //   this.$store.state.auth.userData.permissions
    //     ? (await this.$store.state.auth.userData.permissions.permissions
    //         .length) > 0
    //     : false;
    await this.$store.commit(
      "appConfig/UPDATE_NAV_MENU_HIDDEN",
      Object.keys(this.userData).length == 0
    );
  },
   mounted() {
    setTimeout(async () => {
      if (this.$route.meta.hasPermission) await this.getUser();
    }, 500);
  },

  setup() {
    const { skin, skinClasses, isNavMenuHidden } = useAppConfig();
    const { enableScrollToTop } = $themeConfig.layout;
    // If skin is dark when initialized => Add class to body
    if (skin.value === "dark") document.body.classList.add("dark-layout");

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    // provideToast({
    //   hideProgressBar: true,
    //   closeOnClick: false,
    //   closeButton: false,
    //   icon: false,
    //   timeout: 3000,
    //   transition: "Vue-Toastification__fade",
    // });

    // Set Window Width in store
    store.commit("app/UPDATE_WINDOW_WIDTH", window.innerWidth);

    const { width: windowWidth } = useWindowSize();
    watch(windowWidth, (val) => {
      store.commit("app/UPDATE_WINDOW_WIDTH", val);
    });

    return {
      skinClasses,
      enableScrollToTop,
    };
  },
};
</script>
